module.exports = __webpack_public_path__ + "img/remixicon.symbol.0fbb5ce7.svg";